import PropTypes from 'prop-types';
import { MdKeyboardBackspace } from 'react-icons/md';
import {
  PrimaryButton,
  PrimaryOutlineButton,
} from '../button/button-component';
import Styled from './black-bottom-bar-style';

/**
 * The black bottom bar that will be at the bottom of the pages with a black background and two buttons
 * @param {object} props The props of the BlackBottomBar component.
 * @param {string} props.buttonLeftTitle The title of the left button.
 * @param {string} props.buttonRightTitle The title of the right button.
 * @param {Function} props.buttonRightOnClick The onClick function of the right button.
 * @param {Function} props.buttonLeftOnClick The onClick function of the left button.
 * @param {boolean} props.buttonRightDisabled The disabled state of the right button.
 * @returns {JSX.Element} The rendered BlackBottomBar component.
 */
const BlackBottomBar = ({
  buttonLeftTitle,
  buttonRightTitle,
  buttonRightDisabled,
  buttonRightOnClick,
  buttonLeftOnClick,
}) => {
  const leftButtonStyle = {
    color: 'white',
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: 'white',
  };

  const leftButtonTextStyle = {
    color: 'white',
    borderWidth: 1,
    borderColor: 'white',
  };

  return (
    <Styled.BlackContainer>
      <PrimaryOutlineButton
        title={buttonLeftTitle}
        icon={<MdKeyboardBackspace />}
        onClick={buttonLeftOnClick}
        buttonHeight="32px"
        textStyle={leftButtonTextStyle}
        style={leftButtonStyle}
      />
      <PrimaryButton
        title={buttonRightTitle}
        disabled={buttonRightDisabled}
        onClick={buttonRightOnClick}
        type="submit"
        buttonHeight="32px"
        textStyle={{ marginLeft: '10px', marginRight: '10px' }}
      />
    </Styled.BlackContainer>
  );
};

BlackBottomBar.propTypes = {
  buttonLeftOnClick: PropTypes.func,
  buttonLeftTitle: PropTypes.string,
  buttonRightOnClick: PropTypes.func,
  buttonRightTitle: PropTypes.string,
  buttonRightDisabled: PropTypes.bool,
};

BlackBottomBar.defaultProps = {
  buttonLeftOnClick: () => {},
  buttonLeftTitle: 'Back',
  buttonRightOnClick: () => {},
  buttonRightTitle: 'Next',
  buttonRightDisabled: false,
};

export default BlackBottomBar;
